<template>
  <v-card class="ma-2">
    <v-fab-transition v-if="readonly">
      <v-btn
        class="drag-handle mt-2"
        color="blue darken-2"
        fab
        dark
        small
        absolute
        top
        right
        >
        <v-icon>drag_handle</v-icon>
      </v-btn>
    </v-fab-transition>
    
    <v-card-text class="pa-1">

      <!-- Trait Name -->
      <v-row no-gutters>
        <v-col class="pl-3">
          <span class="subtitle-1 font-weight-medium">
            {{ getTraitDescription(criterion) }}
          </span>
        </v-col>
      </v-row>

      <!-- Trait Value (if RangeSlilder) -->
      <v-row no-gutters>
        <v-col class="pl-3">
          <span v-if="criterion.inputTypeId === inputTypeId_RangeSlider" class="body-1">
            {{ getCriteriaDescription(criterion) }}
          </span>
        </v-col>
      </v-row>

      <!-- Dropdown -->
      <v-row no-gutters>
        <v-col class="pl-3">
          <v-select
            v-if="criterion.inputTypeId === inputTypeId_Dropdown"
            v-model="criterion.value"
            :items="criterion.dropdownItems"
            :disabled="readonly"
            hide-details
            chips
            class="mt-0 pt-0"
          />

          <!-- Range Slider -->
          <v-range-slider
            v-if="criterion.inputTypeId === inputTypeId_RangeSlider"
            v-model="criterion.minMaxValue"
            class="ml-2 mr-2"
            :min="criterion.minMaxRange[0]"
            :max="criterion.minMaxRange[1]"
            :step="criterion.increment"
            ticks="always"
            tick-size="1"
            :disabled="readonly"
            hide-details
          />

          <!-- Multi-select -->
          <v-select
            v-if="criterion.inputTypeId === inputTypeId_MultiSelect"
            v-model="criterion.multiSelectValues"
            :items="criterion.multiSelectItems"
            multiple
            chips
            hint="Selection required"
            :disabled="readonly"
            hide-details
            class="pt-0"
          />

          <!-- Percentile -->
          <v-radio-group
            v-if="criterion.inputTypeId === inputTypeId_Percentile"
            v-model="criterion.value"
            row
            :disabled="readonly"
            hide-details
            class="pb-2 px-1"
            >
            <v-radio
              value="B10"
              color="primary"
              >
              <template v-slot:label>
                <v-icon small>
                  arrow_downward
                </v-icon><span class="caption">10%</span>
              </template>
            </v-radio>
            <v-radio
              value="B25"
              color="primary"
              >
              <template v-slot:label>
                <v-icon small>
                  arrow_downward
                </v-icon><span class="caption">25%</span>
              </template>
            </v-radio>
            <v-radio
              value="B40"
              color="primary"
              >
              <template v-slot:label>
                <v-icon small>
                  arrow_downward
                </v-icon><span class="caption">40%</span>
              </template>
            </v-radio>
            <v-radio
              value="T10"
              color="primary"
              >
              <template v-slot:label>
                <v-icon small>
                  arrow_upward
                </v-icon><span class="caption">10%</span>
              </template>
            </v-radio>
            <v-radio
              value="T25"
              color="primary"
              >
              <template v-slot:label>
                <v-icon small>
                  arrow_upward
                </v-icon><span class="caption">25%</span>
              </template>
            </v-radio>
            <v-radio
              value="T40"
              color="primary"
              style="margin: 0"
              >
              <template v-slot:label>
                <v-icon small>
                  arrow_upward
                </v-icon><span class="caption">40%</span>
              </template>
            </v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { AppColor, InputTypeId  } from '@/config.js'

export default {
  name: 'UserTrait',
  props: {
    criterion: {
      type: Object,
      default: null
    },
    userCiteria: {
      type: Object,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      // colours
      appColor_Trait: AppColor.Trait,

      // input type ids
      inputTypeId_Dropdown: InputTypeId.Dropdown,
      inputTypeId_RangeSlider: InputTypeId.RangeSlider,
      inputTypeId_MultiSelect: InputTypeId.MultiSelect,
      inputTypeId_Percentile: InputTypeId.Percentile,

      // for the percentile radio group
      row: null
    }
  },
  methods: {
    getTraitDescription (criterion) {
      return criterion.group === 'EBV'
        ? criterion.description + ' (EBV)'
        : criterion.description
    },

    getCriteriaDescription (criterion) {

      // ----  Range Slider  ----
      if (criterion.inputTypeId === this.inputTypeId_RangeSlider) {
        if (criterion.unit !== 'score') {
          if (criterion.minMaxValue[0] === criterion.minMaxValue[1]) {
            return criterion.minMaxValue[0] + ' ' + criterion.unit
          } else {
            return criterion.minMaxValue[0] + ' - ' + criterion.minMaxValue[1] + ' ' + criterion.unit
          }
        } else {
          if (criterion.minMaxValue[0] === criterion.minMaxValue[1]) {
            return 'Score of ' + criterion.minMaxValue[0]
          } else {
            return 'Score between ' + criterion.minMaxValue[0] + ' and ' + criterion.minMaxValue[1]
          }
        }

      // ----  Dropdown  ----
      } else if (criterion.inputTypeId === this.inputTypeId_Dropdown) {
        var items = criterion.dropdownItems.filter(function (value) {
          return value.value === criterion.value
        })

        if (items.length > 0) return items[0].text
        return ''

      // ----  Multi-select  ----
      } else if (criterion.inputTypeId === this.inputTypeId_MultiSelect) {
        return criterion.multiSelectValues.join()
      }
    }
  }
}
</script>

<style>
.drag-handle:hover {
  cursor: grab;
  cursor: -webkit-grab;
}
</style>
